import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { initPwa } from "./lib/pwa.js";

import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";
import "./styles/pages.css";

initPwa();

const container = document.getElementById("root");
createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
